import { EntityRepository, uuid } from "../";
import { Counterparty } from "../domain";

class CounterpartyRepository implements EntityRepository<Counterparty> {
  private _repo: EntityRepository<Counterparty>;
  private _defaultCounterparty: Counterparty | undefined;

  constructor(repo:EntityRepository<Counterparty>) {
    this._repo = repo;
  }
  checkUniqueString(attribute: (obj: Counterparty) => string, value: string): boolean {
    return this._repo.checkUniqueString(attribute, value);
  }

  getAll(): Counterparty[] {
    return this._repo.getAll();
  }
  get(uuid: string): Counterparty | undefined {
    return this._repo.get(uuid);
  }
  put(uuid: string, value: Counterparty): Promise<void> {
    return this._repo.put(uuid, value);
  }
  async putAll(values: Counterparty[]) {
    return this._repo.putAll(values);
  }
  delete(uuid: string): void {
    this._repo.delete(uuid);
  }
  addDefaultCounterparty() {
    const counterparty = new Counterparty(uuid(), "");
    this.put(counterparty.uuid, counterparty);
    return counterparty;
  }
  getDefaultCounterparty() : Counterparty {
    if (this._defaultCounterparty) {
      return this._defaultCounterparty;
    }
    const counterparties = this.getAll();
    if (counterparties && counterparties.length > 0 ) {
      this._defaultCounterparty = counterparties.find(cp => cp.name === "");
      if (this._defaultCounterparty) {
        return this._defaultCounterparty;
      }
    }

    this._defaultCounterparty = this.addDefaultCounterparty();
    return this._defaultCounterparty;
  }
}

export { CounterpartyRepository };